import { ACTIONS } from 'actions/home-details';
import { utils as reducerUtils, store } from 'redux-rest-reducer';

import RestReducer from './reducer';

export default RestReducer(ACTIONS, (state, { type, payload }) => {
  switch (type) {
    case ACTIONS.INVALIDATE_ITEM:
      return reducerUtils.changeItemToStale(state, payload.id);
    default:
      return state;
  }
});

const getStudentHomeDetails = (homeDetails, studentId) => {
  const { data: studentHomeDetails } = store.get(homeDetails, studentId) || {};

  return studentHomeDetails;
};

export function getStudentDetails(homeDetails, studentId) {
  const { data: studenthomeDetails } = store.get(homeDetails, studentId) || {};
  const { student: studentDetails } = studenthomeDetails || {};

  return studentDetails;
}

export const getStudentExtraDetails = (homeDetails, studentId) => {
  const studentHomeDetails = getStudentHomeDetails(homeDetails, studentId);
  const { extra_fields: extraFields } = studentHomeDetails || {};

  return extraFields;
};

export const getStudentCourses = (homeDetails, studentId) => {
  const studentHomeDetails = getStudentHomeDetails(homeDetails, studentId);
  const { student_courses: studentCourses } = studentHomeDetails || {};

  return studentCourses;
};
